import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { SmartLinkWidgetType } from 'fym-common/src/db/enums';
import { SerializedProfileWidget } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../../../../common/types';
import { WidgetEditionProps } from '../../props';
import { SMLFormContainer } from '../../../../SMLFormContainer/SMLFormContainer';
import { useSMLRouter } from '../../../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../../../routing/sml/SMLRoutes';
import { SMLButton } from '../../../../../common/views/SMLButton/SMLButton';
import { SMLSettingsTabId } from '../../../../../settings/tabs/types';

const ProfileWidgetEditionViewComponent: React.FC<WidgetEditionProps<SerializedProfileWidget>> = ({
  widget,
  saveWidget,
  deleteWidget,
  isLoading,
  error,
  accountId,
  smartLinkId,
}) => {
  const intl = useIntl();
  const onSave = useCallback(() => {
    saveWidget({}, SmartLinkWidgetType.profile).catch(console.error);
  }, [saveWidget]);
  const isEdition = !!widget;
  const router = useSMLRouter();

  const goToArtistSettings = useCallback(() => {
    router.popToRoot();
    router.push(SMLRoutes.settings, { tab: SMLSettingsTabId.artist });
  }, [router]);

  const backRouteParams = useMemo(() => ({ accountId, smartLinkId }), [accountId, smartLinkId]);
  return (
    <SMLFormContainer
      backRoute={SMLRoutes.details}
      backRouteParams={backRouteParams}
      title={intl.formatMessage({
        id: 'app.smart_links.widgets.profile.title',
        defaultMessage: 'Profile Widget',
      })}
      help={intl.formatMessage({
        id: 'app.smart-links.widgets.profile.subtitle',
        defaultMessage: "This widget displays your account's avatar and name",
      })}
      onSubmit={isEdition ? undefined : onSave}
      onDelete={!isEdition ? undefined : deleteWidget}
      isLoading={isLoading}
      error={error}
    >
      {isEdition && (
        <SMLButton onClick={goToArtistSettings}>
          {intl.formatMessage({
            id: 'app.smart-links.widgets.profile.open_artist_settings',
            defaultMessage: 'Change it in Settings → Artist',
          })}
        </SMLButton>
      )}
    </SMLFormContainer>
  );
};

export const ProfileWidgetEditionView = TypedMemo(ProfileWidgetEditionViewComponent);
